// DEBUG-only sign-in IP override storage.
// Lives separately from runtime impersonation state because the SignInService
// roundtrip blows away in-memory React state. After a successful sign-in the
// stored value is copied into the regular impersonation context and cleared.

const SIGNIN_IP_KEY = "webadmincc-signin-override-ip";

export function getSignInOverrideIP(): string | null {
  if (!__DEV_FEATURES__) return null;
  try {
    const v = localStorage.getItem(SIGNIN_IP_KEY);
    return v && v.trim() ? v.trim() : null;
  } catch {
    return null;
  }
}

export function setSignInOverrideIP(ip: string | null): void {
  if (!__DEV_FEATURES__) return;
  try {
    if (ip && ip.trim()) localStorage.setItem(SIGNIN_IP_KEY, ip.trim());
    else localStorage.removeItem(SIGNIN_IP_KEY);
  } catch {
    // localStorage unavailable — non-fatal
  }
}

export function clearSignInOverrideIP(): void {
  setSignInOverrideIP(null);
}
